/**
 * Header photographs that more than one layer has to name.
 *
 * Most page heroes hold their own path inline, which is right — the path is
 * used once, next to the heading it sits behind. This module exists only for
 * the ones a *second* module also needs, and it is deliberately dependency-free
 * so the router can import it: every container has a `loadable.tsx` wrapping it
 * in `React.lazy`, so importing a constant out of a container's `index.tsx`
 * would pull that whole page into the main bundle and undo the code-splitting.
 *
 * Provenance and the rules for adding to `public/photos/` are in
 * docs/LEGAL-BLOCKERS.md §5.
 */

/**
 * `/my-farm`. Needed by the page itself and by the signed-out gate that the
 * router renders in its place, which must open on the same image.
 */
export const MY_FARM_HEADER_IMAGE = "/photos/my-farm-header.webp";
